import * as Yup from "yup"
import { REGEX_URL_WILDCARD } from "../../../../constants"

export const createOrgFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  website: Yup.string().matches(REGEX_URL_WILDCARD, "Invalid Website URL"),
  about: Yup.string()
})
